import { Badge } from 'reactstrap';
import { BiCheckCircle, BiTime, BiErrorCircle, BiLockAlt } from 'react-icons/bi';

// Compact accounting-sync indicator for list rows. Renders nothing for "none"
// (org not connected, or record never synced) so non-users see no clutter.
const META = {
    synced: { label: 'Synced', color: 'success', Icon: BiCheckCircle },
    pending: { label: 'Syncing', color: 'warning', Icon: BiTime },
    failed: { label: 'Sync failed', color: 'danger', Icon: BiErrorCircle },
    locked: { label: 'Paid', color: 'secondary', Icon: BiLockAlt },
};

export default function AccountingStatusPill({ status }) {
    const meta = META[status];
    if (!meta) return null;
    const { Icon } = meta;
    return (
        <Badge color={meta.color} pill className="d-inline-flex align-items-center gap-1">
            <Icon /> {meta.label}
        </Badge>
    );
}
